import { EditSelectable } from '../formControls/edit-selectable';
import { IssueStatusGroup } from './issue-status-group';

export class IssueStatus implements EditSelectable {
  _id: string;
  code: string;
  label: string;
  roles: string[];
  color: string;
  statusGroup: IssueStatusGroup | undefined;
  settings: any;

  constructor(payload?: any) {
    if (payload) {
      this._id = payload.id;
      this.code = payload.code;
      this.label = payload.label;
      this.roles = payload.roles;
      this.color = payload.color;
      this.statusGroup = payload.statusGroup ? new IssueStatusGroup(payload.statusGroup) : undefined;
      this.settings = payload.settings || {};
    }
  }

  get name(): string {
    return this.label;
  }

  get disabled(): boolean {
    return this.settings?.disabled;
  }

  get id(): string {
    return this.code;
  }

  static createIssueStatuses(result: Array<any>): IssueStatus[] {
    if (!result) {
      return [];
    }
    const issueStatuses = new Array<IssueStatus>();
    result.map((issueStatus) => {
      issueStatuses.push(new IssueStatus(issueStatus));
    });
    return issueStatuses;
  }
}
